// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface APITokenUserDTO extends EntitySelectorDTO { 
	id: string | null | null;
	apiName: string | null;
	apiKey: string | null;
	roleIds: string[];
	roles: string[];
}

const APITokenUserDTO = {
    className: 'APITokenUserDTO',
    create: (initValues?: Partial<APITokenUserDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: null,
			apiName: "",
			apiKey: "",
			roleIds: [],
			roles: [],
        },
        initValues);
    },
	id: 'id',
	apiName: 'apiName',
	apiKey: 'apiKey',
	roleIds: 'roleIds',
	roles: 'roles',
};

export default APITokenUserDTO;